import React, { PureComponent } from 'react';

interface ITabTemplateProps {
    source: any;
}

class TabTemplate extends PureComponent<ITabTemplateProps, any> {
    constructor(props: ITabTemplateProps) {
        super(props);
    }

    public render() {
        const { source } = this.props;

        return (
            <span className="tab-template-part" >{/* TODO  */}</span>
        );
    }
}

export default TabTemplate;
